import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { Form, Container, Row, Col } from 'react-bootstrap';
import { appActions } from '../../../store/slices';
import { addUser } from '../../../service/auth';
import CustomInput from '../../atoms/Input';
import Button from '../../atoms/Button';
import { UtilityFunctions } from '../../../utils';

export default function SignUpForm({ header, setLoginMode }) {
    const [disabled, setDisabled] = useState(true);
    const [values, setValues] = useState({
        name: '',
        surname: '',
        email: '',
        companyCode: '',
        password: '',
        passwordConfirmation: '',
    });

    const [errors, setErrors] = useState({
        name: '',
        surname: '',
        email: '',
        companyCode: '',
        password: '',
        passwordConfirmation: '',
    });

    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.app.isLoading);

    const { name, surname, email, companyCode, password, passwordConfirmation } = values;

    const handleInput = (e) => {
        const { name, value } = e.target;

        setErrors((prevState) => {
            return {
                ...prevState,
                [name]: '',
            };
        });

        setValues({
            ...values,
            [name]: value,
        });
    };

    //checks if every element in the form has value
    const disableForm = Object.values(values).every((value) => value);

    useEffect(() => {
        if (isLoading || !disableForm) setDisabled(true);
        else if (!isLoading && disableForm) setDisabled(false);
    }, [isLoading, disableForm]);

    const handleSignUp = async (e) => {
        e.preventDefault();

        const validatedForm = UtilityFunctions.validateForm('signUp', errors, values);

        if (validatedForm.error) {
            setErrors(validatedForm.errors);
            return;
        }

        try {
            dispatch(appActions.setLoading(true));
            const data = await addUser(email, password, name, surname);
            console.log(data);
            setLoginMode(true);
        } catch (error) {
            console.log(`Error occured: ${error}`);
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };

    return (
        <Container>
            <Form>
                <h2>{header}</h2>
                <Row>
                    <Col>
                        <CustomInput
                            id={'name'}
                            name={'name'}
                            value={name}
                            label={'Ad'}
                            placeholder={'Adınızı giriniz'}
                            onChange={handleInput}
                            error={errors.name}
                        />
                    </Col>
                    <Col>
                        <CustomInput
                            id={'surname'}
                            name={'surname'}
                            value={surname}
                            label={'Soyad'}
                            placeholder={'Soyadınızı giriniz'}
                            onChange={handleInput}
                            error={errors.surname}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CustomInput
                            id={'sign-up-email'}
                            name={'email'}
                            value={email}
                            label={'E-posta Adresi'}
                            placeholder={'E-posta giriniz'}
                            onChange={handleInput}
                            error={errors.email}
                        />
                    </Col>
                    <Col>
                        <CustomInput
                            id={'sign-up-company-code'}
                            name={'companyCode'}
                            value={companyCode}
                            label={'Şirket Kodu'}
                            placeholder={'Kod giriniz'}
                            onChange={handleInput}
                            error={errors.companyCode}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CustomInput
                            id={'sign-up-password'}
                            name={'password'}
                            value={password}
                            label={'Şifre'}
                            placeholder={'Şifre giriniz'}
                            isPassword
                            onChange={handleInput}
                            error={errors.password}
                        />
                    </Col>
                    <Col>
                        <CustomInput
                            id={'sign-up-password-verification'}
                            name={'passwordConfirmation'}
                            value={passwordConfirmation}
                            label={'Şifre (Tekrar)'}
                            placeholder={'Şifreyi tekrar giriniz'}
                            isPassword
                            onChange={handleInput}
                            error={errors.passwordConfirmation}
                        />
                    </Col>
                </Row>
                <Row className='justify-content-md-center'>
                    <Button
                        title={'Kayıt Ol'}
                        onClick={handleSignUp}
                        loading={isLoading}
                        async
                        disabled={disabled}
                        type='submit'
                    />
                    <span className='redirect-link mt-3' onClick={() => setLoginMode(true)}>
                        Giriş Yap
                    </span>
                </Row>
            </Form>
        </Container>
    );
}